import { render, staticRenderFns } from "./RepoPreview.vue?vue&type=template&id=59c7d39d&scoped=true&"
import script from "./RepoPreview.vue?vue&type=script&lang=js&"
export * from "./RepoPreview.vue?vue&type=script&lang=js&"
import style0 from "./RepoPreview.vue?vue&type=style&index=0&id=59c7d39d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c7d39d",
  null
  
)

export default component.exports